import React from 'react';
import { useTranslation } from 'react-i18next';
import { isValidPublicKey } from '../../utils/account.tsx';
import { CaptionText, FlexColumn } from '@make-software/cspr-design';
import { BodyText, Tooltip } from '@block-explorer/ui';

const TooltipWithExtendedInfo = ({
  extendedLine,
  hash,
  tooltipCaption,
  children,
}: React.PropsWithChildren<{
  hash: string;
  tooltipCaption?: string;
  extendedLine?: {
    title: string | undefined;
    caption: string;
  };
}>) => {
  const { t } = useTranslation();

  const hasExtendedLine = extendedLine?.title != undefined;

  const keyTooltipCaption = tooltipCaption
    ? tooltipCaption
    : isValidPublicKey(hash)
      ? t('Public Key')
      : t('Account hash');

  const title = hasExtendedLine ? extendedLine?.title : hash;
  const caption = hasExtendedLine ? extendedLine?.caption : keyTooltipCaption;

  const additionalBlock = hasExtendedLine && (
    <FlexColumn>
      <CaptionText size={1} variation={'gray'}>
        {keyTooltipCaption}
      </CaptionText>
      <BodyText size={3} monotype>
        {hash}
      </BodyText>
    </FlexColumn>
  );

  return (
    <Tooltip
      monotype={!hasExtendedLine}
      tooltipContent={title}
      caption={caption}
      additionalBlock={additionalBlock}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipWithExtendedInfo;
